import { queryOptions } from '@tanstack/react-query';

import { companyApi } from './api-handlers';
import { companyQueryKeys } from './query-keys';

export const companyQueryOptions = {
    getAvailableCompaniesQueryOptions: () =>
        queryOptions({
            queryKey: companyQueryKeys.available(),
            queryFn: () => companyApi.getAvailableCompanies(),
            staleTime: 30_000,
        }),
};
